export interface Country {
  code: string;
  name: string;
  nameAr: string;
  dialCode: string;
  flag: string;
  pattern: RegExp;
  placeholder: string;
  maxLength: number;
  popular?: boolean;
}

export const countries: Country[] = [
  { code: "SA", name: "Saudi Arabia", nameAr: "السعودية", dialCode: "+966", flag: "🇸🇦", pattern: /^5\d{8}$/, placeholder: "5XXXXXXXX", maxLength: 9, popular: true },
  { code: "AE", name: "UAE", nameAr: "الإمارات", dialCode: "+971", flag: "🇦🇪", pattern: /^5\d{8}$/, placeholder: "5XXXXXXXX", maxLength: 9, popular: true },
  { code: "KW", name: "Kuwait", nameAr: "الكويت", dialCode: "+965", flag: "🇰🇼", pattern: /^\d{8}$/, placeholder: "XXXXXXXX", maxLength: 8, popular: true },
  { code: "BH", name: "Bahrain", nameAr: "البحرين", dialCode: "+973", flag: "🇧🇭", pattern: /^\d{8}$/, placeholder: "XXXXXXXX", maxLength: 8, popular: true },
  { code: "QA", name: "Qatar", nameAr: "قطر", dialCode: "+974", flag: "🇶🇦", pattern: /^\d{8}$/, placeholder: "XXXXXXXX", maxLength: 8, popular: true },
  { code: "EG", name: "Egypt", nameAr: "مصر", dialCode: "+20", flag: "🇪🇬", pattern: /^1\d{9}$/, placeholder: "1XXXXXXXXX", maxLength: 10, popular: true },
  { code: "JO", name: "Jordan", nameAr: "الأردن", dialCode: "+962", flag: "🇯🇴", pattern: /^7\d{8}$/, placeholder: "7XXXXXXXX", maxLength: 9, popular: true },
  { code: "OM", name: "Oman", nameAr: "عمان", dialCode: "+968", flag: "🇴🇲", pattern: /^\d{8}$/, placeholder: "XXXXXXXX", maxLength: 8 },
  { code: "IQ", name: "Iraq", nameAr: "العراق", dialCode: "+964", flag: "🇮🇶", pattern: /^7\d{9}$/, placeholder: "7XXXXXXXXX", maxLength: 10 },
  { code: "LB", name: "Lebanon", nameAr: "لبنان", dialCode: "+961", flag: "🇱🇧", pattern: /^\d{7,8}$/, placeholder: "XXXXXXXX", maxLength: 8 },
  { code: "SY", name: "Syria", nameAr: "سوريا", dialCode: "+963", flag: "🇸🇾", pattern: /^9\d{8}$/, placeholder: "9XXXXXXXX", maxLength: 9 },
  { code: "YE", name: "Yemen", nameAr: "اليمن", dialCode: "+967", flag: "🇾🇪", pattern: /^7\d{8}$/, placeholder: "7XXXXXXXX", maxLength: 9 },
  { code: "SD", name: "Sudan", nameAr: "السودان", dialCode: "+249", flag: "🇸🇩", pattern: /^9\d{8}$/, placeholder: "9XXXXXXXX", maxLength: 9 },
  { code: "LY", name: "Libya", nameAr: "ليبيا", dialCode: "+218", flag: "🇱🇾", pattern: /^9\d{8}$/, placeholder: "9XXXXXXXX", maxLength: 9 },
  { code: "TN", name: "Tunisia", nameAr: "تونس", dialCode: "+216", flag: "🇹🇳", pattern: /^\d{8}$/, placeholder: "XXXXXXXX", maxLength: 8 },
  { code: "MA", name: "Morocco", nameAr: "المغرب", dialCode: "+212", flag: "🇲🇦", pattern: /^6\d{8}$/, placeholder: "6XXXXXXXX", maxLength: 9 },
  { code: "DZ", name: "Algeria", nameAr: "الجزائر", dialCode: "+213", flag: "🇩🇿", pattern: /^[567]\d{8}$/, placeholder: "5XXXXXXXX", maxLength: 9 },
  { code: "TR", name: "Turkey", nameAr: "تركيا", dialCode: "+90", flag: "🇹🇷", pattern: /^5\d{9}$/, placeholder: "5XXXXXXXXX", maxLength: 10 },
  { code: "PK", name: "Pakistan", nameAr: "باكستان", dialCode: "+92", flag: "🇵🇰", pattern: /^3\d{9}$/, placeholder: "3XXXXXXXXX", maxLength: 10 },
  { code: "IN", name: "India", nameAr: "الهند", dialCode: "+91", flag: "🇮🇳", pattern: /^[6-9]\d{9}$/, placeholder: "9XXXXXXXXX", maxLength: 10 },
  { code: "US", name: "United States", nameAr: "الولايات المتحدة", dialCode: "+1", flag: "🇺🇸", pattern: /^\d{10}$/, placeholder: "XXXXXXXXXX", maxLength: 10 },
  { code: "GB", name: "United Kingdom", nameAr: "المملكة المتحدة", dialCode: "+44", flag: "🇬🇧", pattern: /^7\d{9}$/, placeholder: "7XXXXXXXXX", maxLength: 10 },
];

export function getDefaultCountry(): Country {
  return countries.find(c => c.code === "SA")!;
}

export function validatePhone(mobile: string, country: Country): boolean {
  const cleaned = mobile.replace(/\D/g, "");
  return country.pattern.test(cleaned);
}

export function cleanPhoneNumber(mobile: string): string {
  return mobile.replace(/\D/g, "").replace(/^0+/, "");
}

export function formatPhoneDisplay(mobile: string): string {
  const cleaned = mobile.replace(/\D/g, "");
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) return `${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
  return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5)}`;
}
